
import { add_component_to_canvas, create_thread_fail, delete_thread_fail, delete_thread_sucsess, fetch_thread_list_failed, fetch_thread_list_start_loading, fetch_thread_list_success, set_component_to_canvas, set_dashboard_category, set_dashboard_category_by_group, set_dashboard_list, set_dashboard_list_loader, set_dashboard_loader, set_drag_drop_canvas_loader, set_fav_prompt_list, set_group_bot_list, set_side_panel_loader, set_workflow_loader, set_workflow_node_list } from "./reducer";
import { build_work_flow, clear_context, create_new_thread, dashboard_board_update, dashboard_create, dashboard_element, dashboard_list, delete_dashboard, delete_Thread, delete_thread_bulk, edit_Thread_title, fetch_dashboard_category, fetch_fav_prompt_by_group_id, get_dashboard_elements, get_group_bot_list, get_Threads, node_list, save_dashboard } from "../../helpers/fakebackend_helper";
import { open_success_modal } from "../Success_Modal/reducer";
import { uniqueId } from "lodash";
import { Bot_Chat_History_mongo } from "../thunks";
import config from "../../config";
import { get_dashboard_category } from "../../helpers/url_helper";






export const FETCH_DASHBOARD_LIST = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(set_dashboard_list_loader(true))
    
 
      response = dashboard_list(filterData);
    
    
    var data = await response;

     if(data){
       dispatch(set_dashboard_list(data))
       if(data){
       dispatch(set_dashboard_list(data))
      //  if (data.data.length == 1){
      //     let fav_list = fetch_fav_prompt_by_group_id({group_id:data.data[0].Group_Id})
      //     let fav_list_response = await fav_list
      //     dispatch(set_fav_prompt_list(fav_list_response))
      //  }
     }
     }


      

     dispatch(set_dashboard_list_loader(false))

   
    
  } catch (error) {
    console.log("Error While Fetching Workflow Node list",error);
    
    dispatch(set_dashboard_list_loader(false))
  }
};


export const CREATE_DASHBOARD = (filterData,navigate) => async (dispatch) => {



    try {
      let response;
      
       const data = new FormData();
        // console.log(filterData.Dashboard_Logo)
        
          data.append('Group_Id',filterData.group_id)
          data.append('Dashboard_Category',filterData.dashboard_category)
          data.append('Dashboard_Title',filterData.dashboard_name)
          data.append('Dashboard_Description',filterData.dashboarddescription)
          data.append('Dashboard_Logo',filterData.Dashboard_Logo)
       
  
  
      dispatch(set_dashboard_loader(true))
      
   
        response = dashboard_create(data);
      
      
      var create_dashboard = await response;
 
  
       dispatch(set_dashboard_loader(false))
        dispatch(open_success_modal(" Dashboard created Successfully. "))
        // Redirect to creation dashboard.
        navigate('/Dashboard_st', {
            state: { Dashboard_Id: create_dashboard.group_dashboard.Dashboard_Id }
        })
     
      
    } catch (error) {
      // console.log("Error While creating Dashboard ",error);
      
      dispatch(set_dashboard_loader(false))
    }
  };


  export const DELETE_DASHBOARD = ({filterData, dashboard_Id}) => async (dispatch) => {



    try {
      let response;
  
     
  
  
  
      dispatch(set_dashboard_loader(true))

      let delete_response = delete_dashboard(dashboard_Id)
      
      await delete_response;
   
        response = dashboard_list(filterData);
      
      
      var data = await response;
  
       if(data){
         dispatch(set_dashboard_list(data))
       }
  
  
        
  
       dispatch(set_dashboard_loader(false))
  
     
      
    } catch (error) {
      console.log("Error While Fetching Workflow Node list",error);
      
      dispatch(set_dashboard_loader(false))
    }
  };


  export const GET_ELEMENT_DATA = (filterData) => async (dispatch) => {

    //  console.log(filterData, "Data is good ");
     

    try {

       
  
  
      dispatch(set_drag_drop_canvas_loader(true))
      
   
        let response = dashboard_element(filterData);
      
        const data = await response

        // console.log(data);
        

        dispatch(add_component_to_canvas({ type:data.visualization, title:filterData.title , data:data.graph_json , favorite_prompt_id:filterData.favorite_prompt_id }))

        // dispatch(GET_DASHBOARD_ELEMENTS(filterData))

      
  
       dispatch(set_drag_drop_canvas_loader(false))
   
     
      
    } catch (error) {
      console.log("Error While creating Dashboard element ",error);
      
      dispatch(set_drag_drop_canvas_loader(false))
    }
  };


  export const SAVE_DASHBOARD = (filterData) => async (dispatch) => {



    try {
  
      dispatch(set_drag_drop_canvas_loader(true))
      
   
        let response = save_dashboard(filterData);
      
        const data = await response
        // console.log(data)
        // dispatch(add_component_to_canvas({ type:filterData.visualization, title:filterData.title , data }))
        dispatch(set_drag_drop_canvas_loader(false))

        dispatch(open_success_modal("Dashboard Saved Successfully"))
     
      
    } catch (error) {
      console.log("Error While creating Dashboard element ",error);
      
      dispatch(set_drag_drop_canvas_loader(false))
    }
  };



  export const GET_DASHBOARD_ELEMENTS = (filterData) => async (dispatch) =>{
          
    

    try {

       
  
  
      dispatch(set_dashboard_loader(true))
      dispatch(set_drag_drop_canvas_loader(true))
   
        let response = get_dashboard_elements(filterData);
      
        const data = await response

        // console.log(data);
  
        let dnd_component_data = data.Dashboard_Graph_Elements.map((ele,index)=>{
          const { Id , Favorite_Prompt_Id , Graph_Type  , Dashboard_Id , X_Axis , Y_Axis , Height , Width , Element_Id , Graph_Data , Graph_Title , X_Axis_Position , Y_Axis_Position , X_Axis_Column , Y_Axis_Column  , Labelling_Column , Theta_Column   } = ele
          return{
              id: Element_Id,
              type:Graph_Type,
              x:X_Axis_Position,
              y:Y_Axis_Position,
              width: Width,
              height: Height,
              favorite_prompt_id:Favorite_Prompt_Id,
              title:Graph_Title,
              data:Graph_Data,
              Y_Axis_Column,
              X_Axis_Column,
              Labelling_Column,
              Theta_Column
          }
        })
        

        dispatch(set_component_to_canvas(dnd_component_data))

        

      
  
       dispatch(set_dashboard_loader(false))
       dispatch(set_drag_drop_canvas_loader(false))
   
     
      
    } catch (error) {
      console.log("Error While creating Dashboard element ",error);
      
      dispatch(set_dashboard_loader(false))
       dispatch(set_drag_drop_canvas_loader(false))

    }

  }


   export const GET_DASHBOARD_CATEGORY = (filterData) => async (dispatch) => {



    try {
  
      // dispatch(set_dashboard_loader(true))
      
   
        let response = fetch_dashboard_category(filterData);
      
        const data = await response
        // console.log(data)
        dispatch(set_dashboard_category(data))
        // dispatch(set_dashboard_loader(false))

   
     
      
    } catch (error) {
      console.log("Error While getting Dashboard Category ",error);
      
      // dispatch(set_dashboard_loader(false))
    }
  };


   export const GET_DASHBOARD_CATEGORY_BY_GROUP = (filterData) => async (dispatch) => {



    try {
  
      // dispatch(set_dashboard_loader(true))
      
   
        let response = fetch_dashboard_category(filterData);
      
        const data = await response
        // console.log(data)
        dispatch(set_dashboard_category_by_group(data))
        // dispatch(set_dashboard_loader(false))

 
     
      
    } catch (error) {
      console.log("Error While getting Dashboard Category ",error);
      
      // dispatch(set_dashboard_loader(false))
    }
  };
  


  export const GET_GROUP_BOT_LIST = (filterData) => async (dispatch) => {



    try {
  
      // dispatch(set_dashboard_loader(true))
      
   
        let response = get_group_bot_list(filterData);
      
        const data = await response
        // console.log(data)
        dispatch(set_group_bot_list(data))
        // dispatch(set_dashboard_loader(false))

 
     
      
    } catch (error) {
      console.log("Error While getting group bot list ",error);
      
      // dispatch(set_dashboard_loader(false))
    }
  };


  export const GET_DASHBOARD_FAV_PROMPT_LIST =(filterData) => async (dispatch) =>{
    try {
dispatch(set_side_panel_loader(true))
       let fav_list = fetch_fav_prompt_by_group_id(filterData)
          let fav_list_response = await fav_list
          dispatch(set_fav_prompt_list(fav_list_response))

dispatch(set_side_panel_loader(false))
    
      
    } catch (error) {
      console.log("Error while fetching fav prompt list .")
    }
        
  }



  export const UPDATE_DASHBOARD_DETAILS =(filterData) => async (dispatch) =>{
    try {
 
dispatch(set_dashboard_loader(true))
 await dashboard_board_update(filterData)


dispatch(set_dashboard_loader(false))
    
      
    } catch (error) {
dispatch(set_dashboard_loader(true))

      console.log("Error while updating Dashboard details .")
    }
        
  }
 


//   export const FETCH_FAV_PROMPT_LIST = (filterData) => async (dispatch) => {



//   try {
//     let response;





//     dispatch(set_dashboard_loader(true))
    
 
//       response = dashboard_list(filterData);
    
    
//     var data = await response;

//      if(data){
//        dispatch(set_dashboard_list(data))
//        if (data.data.length == 1){
//           let fav_list = fetch_fav_prompt_by_group_id({group_id:data.data[0].Group_Id})
//           let fav_list_response = await fav_list()
//           dispatch(set_fav_prompt_list(fav_list_response))
//        }
//      }


      

//      dispatch(set_dashboard_loader(false))

   
    
//   } catch (error) {
//     console.log("Error While Fetching Workflow Node list",error);
    
//     dispatch(set_dashboard_loader(false))
//   }
// };

  
  




  




  


  

